import { createReducer } from 'redux-act';
import * as actions from '#app/actions/tradeCommission';
import type { TradeCommissionFormPayload } from '#app/actions/tradeCommission';

interface TradeCommissionState {
  modalVisible: boolean;
  form: Record<string, unknown>;
  tradeId: number | null;
}

const initialState: TradeCommissionState = {
  modalVisible: false,
  form: {},
  tradeId: null,
};

const setTradeCommissionModalVisible = (
  state: TradeCommissionState,
  bool: boolean
): TradeCommissionState => ({
  ...state,
  modalVisible: bool,
});

const setTradeId = (state: TradeCommissionState, tradeId: number | null): TradeCommissionState => ({
  ...state,
  tradeId: tradeId,
});

const setTradeCommissionForm = (
  state: TradeCommissionState,
  form: TradeCommissionFormPayload
): TradeCommissionState => ({
  ...state,
  form: form ?? {},
});

export default createReducer<TradeCommissionState>(
  {
    [actions.setTradeCommissionModalVisible.getType()]: setTradeCommissionModalVisible,
    [actions.setTradeCommissionForm.getType()]: setTradeCommissionForm,
    [actions.setTradeId.getType()]: setTradeId,
  },
  initialState
);
